import { File as FileIcon, FileSpreadsheet, FileText, Image as ImageIcon, Video } from "lucide-react";

// Display kind by file extension (icon + colour).
const KINDS = [
  { kind: "Image", exts: ["jpg", "jpeg", "png", "gif", "webp", "heic"], icon: ImageIcon, color: "#38BDF8" },
  { kind: "Excel", exts: ["xlsx", "xls", "csv"], icon: FileSpreadsheet, color: "#22C55E" },
  { kind: "PDF", exts: ["pdf"], icon: FileText, color: "#EF4444" },
  { kind: "Video", exts: ["mp4", "mov", "webm"], icon: Video, color: "#A78BFA" },
  { kind: "Word", exts: ["doc", "docx"], icon: FileText, color: "#3B82F6" },
];
const OTHER = { kind: "File", exts: [], icon: FileIcon, color: "#94A3B8" };

export const extOf = (name) => {
  const m = /\.([a-z0-9]{1,10})$/i.exec(String(name || ""));
  return m ? m[1].toLowerCase() : "";
};

export const kindOf = (name) => KINDS.find((k) => k.exts.includes(extOf(name))) || OTHER;

const PREVIEW_MIME = { mp4: "video/mp4", mov: "video/quicktime", webm: "video/webm", pdf: "application/pdf" };
/** MIME used to preview a downloaded blob (the API serves non-images as opaque bytes). */
export const previewMimeOf = (name) => PREVIEW_MIME[extOf(name)] || null;
